import React, { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { Label, Input } from "reactstrap";
import {
  AdPaymentUpdate,
  fetchSettings,
} from "../../../components/Header/Data2";
import { useNavigate, useLocation } from "react-router-dom";
import ThankYouModal from "../Orders/ThankYouPage";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { FadeLoader } from "react-spinners";
import {
  CreateGurdwaraDonation,
  createGurudwaraBooking,
  Featured,
  postSponsordAd,
  sendMessage,
  statusUpdateGurdwaraDonation,
  statusUpdateOrder,
  viewPhonePayment,
} from "../../../components/Header/Data";
import { setFeatureService } from "../../../redux/slices/PaymentSlice";
import axiosClient from "../../../axios-client";
import { getMyCartItems } from "../../../components/Header/MyCart";
import {
  setPaymentStatus,
  setResponseId,
} from "../../../redux/slices/GurdwaraSlice";
import {
  setOrderStatus,
  setPaypalResponse,
} from "../../../redux/slices/MsgSlice";
import {
  setDonationClientId,
  setDonationSecretKey,
  setDonationStatus,
  setModalIsOpen,
  setMonthlyDonation,
  setOpenPaypal,
  setSelectedAmount,
  setSelectedGurdwara,
} from "../../../redux/slices/DonationSlice";
import paypalLogo from "../../../assets/images/paypal-logo.png";
import { setMakeOfferStatus } from "../../../redux/slices/RequestFormSlice";
import { decrementCartCount } from "../../../redux/slices/userSlice";
import useSendMessage from "../../../utils/useSendMessage";
import { reciveOrder } from "../../../redux/slices/OrderSlice";
import { useSocket } from "../../../contexts/SocketContext";
import { setOffer_Late_Fee_Pay_show } from "../../../redux/slices/bwvSlice";

const Payment = ({ totalPrice, adDetails, state, type, chatDetails }) => {
  const paymentSlice = useSelector((state) => state.payment);
  const sendMsg = useSendMessage();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const gurudwaraId = parseInt(queryParams.get("id"), 10);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [thankYou, setThankYou] = useState(false);
  const [clientId, setClientId] = useState("");
  const logUser = user?.Role;
  const dispatch = useDispatch();
  const { selectedServicePrice, responseId, termsConditions, paypalClientID } =
    useSelector((state) => state.gurdwara);
  const { order, selectedConvo, description, childId } = useSelector(
    (state) => state.messages,
  );
  const { sendNewMessage, sendNewOrder, socket } = useSocket();
  const { donationClientId, selectedGurdwara, monthlyDonation, donationFrom } =
    useSelector((state) => state.gurdwaraDonation);
  const formData = useSelector((state) => state.requestForm);
  const isProd = process.env.REACT_APP_PRODUCTION;
  const fetchSet = async () => {
    console.log(paypalClientID, "GurdwaraClientID");
    if (state?.bookingGurdwara && paypalClientID) {
      setClientId(paypalClientID);
    } else {
      const settings = await fetchSettings();
      const filterSet = settings.filter((set) => set.setting_name === "paypal");
      setClientId(filterSet[0]?.client_id);
    }
  };
  const fetchDonationId = async () => {
    if (state?.donation) {
      setClientId(donationClientId);
    }
  };
  useEffect(() => {
    if (state?.donation) {
      fetchDonationId();
    }
  }, [state?.donation]);

  useEffect(() => {
    if (
      adDetails ||
      chatDetails ||
      state?.invoicePay ||
      state?.bookingGurdwara
    ) {
      fetchSet();
    }
  }, [
    adDetails,
    chatDetails,
    state?.bookingGurdwara,
    paypalClientID,
    formData?.clientId,
    state?.needPayment,
    state?.chatPay,
    state?.invoicePay,
    state?.makeOfferPay,
  ]);

  useEffect(() => {
    const loadClientId = async () => {
      try {
        if (clientId) return;
        if (state?.donation && donationClientId) {
          setClientId(donationClientId);
          return;
        }
        const settings = await fetchSettings();
        const filterSet = settings?.filter(
          (set) => set.setting_name === "paypal",
        );
        if (filterSet?.length) setClientId(filterSet[0].client_id);
      } catch (err) {
        toast.error("Unable to load payment settings");
      }
    };

    loadClientId();
  }, [state?.donation, donationClientId]);

  const placeOrder = async (details) => {
    const orderData = localStorage.getItem("ORDER_DETAILS");
    const orderDetails = orderData ? JSON.parse(orderData) : null;
    const orderId =
      orderDetails && orderDetails.orderId
        ? orderDetails.orderId
        : orderDetails.Id
          ? orderDetails.Id
          : 0;
    if (orderId) {
      const originalAmount = Number(orderDetails.totalAmount || 0);
      const paidAmount = Number(totalPrice || 0); // ← make sure totalPrice is defined
      const discountAmount = originalAmount - paidAmount;
      // Extract Authorization ID safely
      let authorizationId = null;
      try {
        const auth =
          details?.purchase_units?.[0]?.payments?.authorizations?.[0];
        if (auth?.id) {
          authorizationId = auth.id;
        }
      } catch (e) {
        console.warn("Could not extract authorization ID", e);
      }

      let formData = {
        status: details.status,
        messageId: state?.selectedConversation
          ? state?.selectedConversation.Id
          : 0,
        Discount: discountAmount > 0 ? discountAmount : 0,
        paidAmount: paidAmount,
        totalAmount: originalAmount,
        cartStatus: 1,
        paypalOrderId: details.id, // fallback to order ID if auth not found
        authorizationId: authorizationId, // optional – uncomment if needed
        paypalResponse: details, // optional – for debugging only
      };
      console.log("Sending to backend →", { formData, orderId });
      try {
        await dispatch(
          reciveOrder({ orderData: formData, id: orderId }),
        ).unwrap();
        dispatch(decrementCartCount());
        toggleModal();
        MessageSend(orderDetails, details);
        localStorage.removeItem("ORDER_DETAILS");
      } catch (error) {
        console.error("Order update failed:", error);
        toast.error("Order update failed");
      }
    } else {
      console.error("Order details are missing or invalid.");
    }
  };
  const handleOfferPayment = async (details) => {
    if (state?.reqPhoneAmount) {
      const orderData = localStorage.getItem("ORDER_DETAILS");
      const orderDetails = orderData ? JSON.parse(orderData) : null;

      const id = state?.msg.Id;
      let formData = {
        senderId: user?.UserID,
        requestPhone: logUser === "provider" ? "provider" : "customer",
        paypalResponse: details,
        createBy:
          selectedConvo.createdBy === user.UserID
            ? user.UserID
            : selectedConvo?.ownerId,
        serviceNeed: state?.msg?.serviceNeed,
        totalAmount: state?.reqPhoneAmount,
        Discount: 0,
        paidAmount: state?.reqPhoneAmount,
        orderStatus: details.status,
      };
      await viewPhonePayment(formData, id);
      let updateOrder = {
        createdBy:
          selectedConvo.createdBy === user.UserID
            ? user.UserID
            : selectedConvo?.ownerId,
        orderStatus: details.status,
        orderId: orderDetails?.Id,
        paypalResponse: details,
      };
      await statusUpdateOrder(updateOrder, orderDetails?.Id);
      toggleModal();
      localStorage.removeItem("ORDER_DETAILS");
    }
  };

  const updateItemOrder = async (details) => {
    if (state?.item) {
      const orderData = localStorage.getItem("ITEM_ORDER_DETAILS");
      const orderDetails = orderData ? JSON.parse(orderData) : null;
      if (orderDetails && orderDetails.id) {
        let formData = {
          orderStatus: details.status,
          cartId: state?.itemOrder?.cart_id,
          itemId: state?.itemOrder?.item_id,
          updatedBy: user.UserID,
        };
        try {
          const response = await axiosClient.put(
            `item/StatusUpdateItemOrder/${orderDetails.id}`,
            formData,
          );
          if (response.data.statusCode === 200) {
            toast.success("Order Placed");
            setTimeout(() => {
              getMyCartItems(user.UserID, dispatch);
            }, 1000);
          }
        } catch {
          toast.error("Payment Incomplete");
        }
        toggleModal();
        localStorage.removeItem("ITEM_ORDER_DETAILS");
      } else {
        console.error("Order details are missing or invalid.");
      }
    }
  };

  const SponsordAdPayment = async (details) => {
    if (adDetails) {
      const request = {
        createdBy: user.UserID,
        paymentStatus: details.status,
      };
      const response = await postSponsordAd(adDetails);
      if (response) {
        const id = response.data.Data.id;
        await AdPaymentUpdate(id, request);
        dispatch(setOrderStatus(details.status));
      }
    }
  };

  const FeaturingService = async (details) => {
    if (paymentSlice.featureService !== null) {
      const reqData = {
        featuredListing: 1,
        updatedBy: user.UserID,
      };
      await Featured(reqData, paymentSlice.featureService.Id);
      dispatch(setFeatureService(null));
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  };

  const bookingPaymentStatus = async (details) => {
    if (state?.bookingGurdwara) {
      let formData = {
        paymentStatus: details.status,
        Amount: selectedServicePrice,
        updatedBy: user?.UserID,
        paymentDetails: details,
        gurudwaraId: gurudwaraId,
        Id: responseId,
      };
      const response = await createGurudwaraBooking(formData);
      dispatch(setPaymentStatus(details?.status));
    }
  };

  const ChatPayment = async (details) => {
    if (state?.chatPay) {
      let formData = {
        customerId: selectedConvo?.customerId,
        postId: selectedConvo?.postId,
        postType: selectedConvo?.postType,
        Description: `payment for chat with ${description}, ${totalPrice}, ${details.status}`,
        ownerId: selectedConvo?.ownerId,
        serviceNeed: "need",
        messageStatus: 8,
        orderStatus: details.status,
        createdBy: user?.UserID,
        payEmail: user?.Email,
        payPhone: `${user?.CountryCode}${user?.Phone}`,
        parentId: selectedConvo?.Id,
        childId: childId,
        Amount: totalPrice,
        orderDescription: description,
        receiverId:
          selectedConvo?.createdBy === user?.UserID
            ? selectedConvo?.customerId
            : selectedConvo?.createdBy,
        userName: user?.UserName,
        Type: "chatpayment",
      };
      await statusUpdateOrder(formData, order);
      dispatch(setOrderStatus(details?.status));
    }
  };
  const formatDate = (dateInput) => {
    if (!dateInput) return "N/A";
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return "N/A";
    const formatter = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    return formatter.format(date).replace(/ /g, " - ");
  };
  const MessageSend = async (orderDetails, details) => {
    const servicePackage =
      (orderDetails && orderDetails?.packageDetails) || "N/A";
    const parsedPackage = JSON.parse(servicePackage);
    const eventDate = orderDetails?.eventDate || "N/A";
    const navUrl = `${process.env.REACT_APP_URL}/#/dashboardpage/orders?orderId=${orderDetails?.Id}`;
    // const description = `Payment of $${totalPrice} for Order ID: ${orderDetails?.Id} has been successfully completed.<br/> <a className="text-primary" href="${navUrl}" target="_blank" rel="noopener noreferrer">Click to view Order →</a>.`;
    const description = `<strong>📢 NEW BOOKING CONFIRMED!</strong>
   <strong>Service Package:</strong> ${parsedPackage?.title || "N/A"}
   <strong>Event Date:</strong> ${formatDate(orderDetails?.reserveDate) || "N/A"}
   <strong>Payment Amount:</strong> $${totalPrice}
   ⏳<em style="font-size:12px; color:#6c757d;">The vendor has <strong>24 hours</strong> to accept or reject the booking request.</em>
   <a href="${navUrl}" target="_blank" rel="noopener noreferrer" style="color:#0d6efd; font-weight:600; text-decoration:none;">👉 Click here to view the order →</a>`;
    const messageForm = {
      customerId: orderDetails?.ownerId || "0",
      postId: orderDetails?.serviceId || "0",
      postType: 1,
      Description: description,
      messageStatus: 8,
      createdBy: orderDetails?.createdBy || user.UserID, // Use updated userId
      ownerId: orderDetails?.ownerId || "0",
      userName: orderDetails?.userName || user?.UserName || "Unknown User", // Use first name from fullName
      Email: orderDetails?.Email || user?.Email || "",
      serviceNeed: "services",
    };
    const response = await sendMessage(messageForm);
    if (response.Data) {
      sendNewOrder(messageForm, orderDetails, orderDetails?.ownerId); // Send order data via WebSocket
    }
  };
  const donateGurdwara = async (details) => {
    if (state?.donation) {
      let formData = {
        gurudwaraId: parseInt(selectedGurdwara),
        Amount: totalPrice,
        recurringDeposit: monthlyDonation ? 1 : 0,
        createdBy: user?.UserID,
      };
      const response = await CreateGurdwaraDonation(formData);
      let updateDonationData = {
        paymentStatus: details.status,
        paymentDetails: details,
      };
      dispatch(setDonationStatus(details.status));
      if (details.status === "COMPLETED") {
        await statusUpdateGurdwaraDonation(response?.id, updateDonationData);
        dispatch(setMonthlyDonation(null));
        dispatch(setSelectedAmount(null));
        dispatch(setSelectedGurdwara(null));
        dispatch(setOpenPaypal(false));
        dispatch(setDonationClientId(""));
        dispatch(setDonationSecretKey(""));
      }
    }
  };

  const invoicePayment = async (details) => {
    if (state?.invoicePay) {
      let formData = {
        orderStatus: details.status,
        paypalResponse: details,
        Amount: totalPrice,
        createdBy: islogin ? user?.UserID : state?.invoice.customer_id,
        invoiceId: state?.invoice?.Id,
        Description: `Payment of $${totalPrice} with Order ID: ${state?.order?.Id} and Invoice ID: ${state?.invoice?.Id} has been successfully completed.`,
        messageId: state?.invoice?.message_id,
      };
      await statusUpdateOrder(formData, state?.order?.Id);
      dispatch(setPaypalResponse(details.status));
    }
  };

  // const makeOfferPayment = async (details) => {
  //   if (state?.makeOfferPay) {
  //     let data = {
  //       orderStatus: details.status,
  //       paypalResponse: details,
  //       Amount: totalPrice,
  //       createdBy: user?.UserID,
  //     };
  //     await statusUpdateOrder(data, formData?.orderId);
  //     dispatch(setMakeOfferStatus(details.status));
  //   }
  // };
  const makeOfferPayment = async (details) => {
    if (state?.makeOfferPay) {
      // Hide the payment UI
      dispatch(setOffer_Late_Fee_Pay_show(false));
      // Mark make-offer as completed so the modal can proceed to "Get Customer"
      dispatch(setMakeOfferStatus("COMPLETED"));
    }
  };

  const toggleModal = () => {
    setThankYou(!thankYou);
  };

  if (!clientId) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "50px",
        }}
      >
        <FadeLoader color="#36d7b7" />
      </div>
    );
  }
  console.log(isProd, typeof isProd, "isProdisProdisProd");
  return (
    <div
      className={`${state?.reqPhoneAmount && totalPrice === 10 && "w-50"} mt-2`}
      style={{
        marginLeft: totalPrice && state?.reqPhoneAmount === 10 && "25%",
      }}
    >
      <PayPalScriptProvider
        options={{
          "client-id":
            isProd === "true"
              ? clientId
              : "AaqY5POsphq_iOg3JGN-H5lxMige1F_HmVlqMiu_sR4RrJzYLg_B8gqjVX1n-0pOlWPe5upN2Zb3q_RU",
          currency: "USD",
          intent: "authorize", // CHANGED: authorize instead of capture
          // Optional: helps show guest card option more reliably in sandbox
          "enable-funding": "card",
        }}
      >
        <PayPalButtons
          disabled={state?.bookingGurdwara ? termsConditions !== 1 : false}
          createOrder={(data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: totalPrice,
                  },
                },
              ],
            });
          }}
          onApprove={async (data, actions) => {
            try {
              // CHANGED: Authorize instead of capture
              const details = await actions.order.authorize();
              console.log("=========22", details.status);
              console.log("=========22", details);
              // Execute all payment-related functions
              if (details.status === "COMPLETED") {
                if (type == "sponsord") {
                  SponsordAdPayment(details);
                } else if (type == "makeOffer") {
                  makeOfferPayment(details);
                } else {
                  placeOrder(details);
                  handleOfferPayment(details);
                  FeaturingService(details);
                  updateItemOrder(details);
                  bookingPaymentStatus(details);
                  ChatPayment(details);
                  donateGurdwara(details);
                  invoicePayment(details);
                }
              }
            } catch (error) {
              console.error("PayPal authorization error", error);
              toast.error("Payment authorization failed. Please try again.");
            }
          }}
          onError={(error) => {
            console.error("PayPal error", error);
            toast.error("Payment failed. Please try again.");
          }}
        />
        <ThankYouModal
          show={thankYou}
          onHide={toggleModal}
          totalPrice={totalPrice}
          state={state}
          orderId={state?.order?.Id || order?.Id}
          orderDetails={state?.order || order}
        />
      </PayPalScriptProvider>
    </div>
  );
};

export default Payment;
